import { Pool } from "../../Utils/Collections/Pool";
import { Parcel } from "./Parcel";
import { NodeList } from "../../Utils/Collections/NodeList";
import { Node } from "../../Utils/Collections/Node";
import { DeliveryPoint } from "./DeliveryPoint";
import { Dispenser } from "./Dispenser";
import { Gameplay } from "../Gameplay";
import { Player } from "../Player/Player";



export class ParcelManager {
    /**
     * (RO) Staticky pristup
     */
    static get instance(): ParcelManager { return ParcelManager._instance; }
    private static _instance: ParcelManager;

    /**
     * (RO) Pool s volnymi baliky
     */
    get freeParcels(): Pool<Parcel> { return this._freeParcels; }
    private _freeParcels: Pool<Parcel>;

    /**
     * Seznam aktivnich baliku, u kterych se vola update
     */
    private _actParcels: NodeList<Parcel>;

    /**
     * (RO) Pole s odbernymi misty pro baliky
     */
    get deliveryPoints(): DeliveryPoint[] { return this._deliveryPoints; }
    private _deliveryPoints: DeliveryPoint[];

    /**
     * (RO) Pole s vydejnimi misty baliku
     */
    get dispensers(): Dispenser[] { return this._dispensers; }
    private _dispensers: Dispenser[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        ParcelManager._instance = this;

        // Pool s volnymi balicky
        let parcelUID = 0;

        this._freeParcels = new Pool<Parcel>(undefined, 0, true, (): Parcel => { return new Parcel(parcelUID++); }, this);
        this._freeParcels.createItems(4);

        // Seznam balicku, u kterych se vola update
        this._actParcels = new NodeList<Parcel>();

        // Vydejny a odberna mista balicku 
        this._dispensers = [];
        this._deliveryPoints = [];

        // Zachytavat udalost doruceni balicku hracem
        Gameplay.instance.events.on(Player.EVENT_PARCEL_DELIVERED, this.handleParcelsDelivered, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): void {
        this._dispensers.forEach((dispenser: Dispenser) => { dispenser.release(); });
        this._dispensers.length = 0;

        this._deliveryPoints.length = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Uvolnit aktivni balicky
        this._actParcels.forEach((parcel: Parcel) => {
            parcel.reset();
        }, this);
        this._actParcels.clear();

        // Vydejny a dodaci mista
        this._dispensers.forEach((dispenser: Dispenser) => { dispenser.reset(); });
        this._deliveryPoints.forEach((point: DeliveryPoint) => { point.reset(); });
    }

    //-------------------------------------------------------------------------
    /**
     * Prida balik do seznamu aktivnich
     * @param parcel 
     */
    //-------------------------------------------------------------------------
    addActParcel(parcel: Parcel): void {
        this._actParcels.add(parcel);
    }

    //-------------------------------------------------------------------------
    /**
     * Aktualizuje aktivni baliky
     */
    //-------------------------------------------------------------------------
    update(): void {
        // Aktivni balicky
        this._actParcels.forEach((parcel: Parcel, node: Node<Parcel>) => {
            if (!parcel.update())
                this._actParcels.removeByNode(node);
        });

        // Vydejny
        this._dispensers.forEach((dispenser: Dispenser) => { dispenser.update(); });

        // Dodaci mista
        this._deliveryPoints.forEach((deliveryPoint: DeliveryPoint) => { deliveryPoint.update(); });
    }

    //-------------------------------------------------------------------------
    /**
     * Pridani vydejny do seznamu vydejen
     * @param worldPos Pozice vydejny v hernim svete na ose Z
     * @param dir Smer vydavani baliku (-1 = vlevo, 1 = vpravo)
     */
    //-------------------------------------------------------------------------
    addDispenser(worldPos: number, dir: number): void {
        this._dispensers.push(new Dispenser(this._dispensers.length, worldPos, dir));
    }

    //-------------------------------------------------------------------------
    /**
     * Pridani odberneho mista do seznamu odbernych mist
     * @param vanEntity 
     * @param worldPos 
     * @param dir Smer odberu (-1 = smerem nahoru, 1 = smerem dolu)
     */
    //-------------------------------------------------------------------------
    addDeliveryPoint(vanEntity: pc.Entity, worldPos: number, dir: number): void {
        this._deliveryPoints.push(new DeliveryPoint(vanEntity, worldPos, dir));
    }

    //-------------------------------------------------------------------------    
    //-------------------------------------------------------------------------
    private handleParcelsDelivered(): void {
        // Doplnit balicky ve vydejnach
        this._dispensers.forEach((dispenser: Dispenser) => { dispenser.refillParcels(); });
    }
}